import React from 'react'

import closeOutlined from '@iconify/icons-ant-design/close-outlined'
import Icon from '@iconify/react'
import styles from './style.module.css'
import { useServiceStatusBanner } from './useServiceStatusBanner'

const ServiceStatusBanner = () => {
  const { banners, dismiss } = useServiceStatusBanner()

  if (!banners.length) {
    return null
  }

  return (
    <>
      {banners.map((banner) => (
        <div key={banner.id} className={`${styles.banner} ${styles[banner.type]}`}>
          <div>
            <span className={styles.content}>{banner.text} </span>

            {banner.link && banner.linkText && (
              <a href={banner.link} target="_blank" rel="noopener noreferrer" className={styles.link}>
                {banner.linkText}
              </a>
            )}
          </div>

          {banner.dismissible && (
            <button aria-label="Закрыть уведомление" type="button" className={styles.close} onClick={() => dismiss(banner.id)}>
              <Icon icon={closeOutlined} />
            </button>
          )}
        </div>
      ))}
    </>
  )
}

export default ServiceStatusBanner
